const BENIGN_RESIZE_OBSERVER_PATTERNS = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];

export function isBenignResizeObserverError(message: unknown): boolean {
  if (typeof message !== 'string' || message.length === 0) {
    return false;
  }
  return BENIGN_RESIZE_OBSERVER_PATTERNS.some((pattern) => message.includes(pattern));
}

/**
 * Suppress the benign W3C ResizeObserver loop notification so it does not
 * trigger the webpack-dev-server runtime error overlay during rapid scrolling.
 * Uses the capture phase so it runs before bubble-phase window error listeners.
 */
export function installResizeObserverErrorFilter(targetWindow: Window = window): () => void {
  const onError = (event: ErrorEvent): void => {
    const errorMessage =
      event.message ||
      (event.error instanceof Error ? event.error.message : undefined);
    if (isBenignResizeObserverError(errorMessage)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };

  targetWindow.addEventListener('error', onError, true);
  return () => {
    targetWindow.removeEventListener('error', onError, true);
  };
}
